// extracted by mini-css-extract-plugin
export default {"root":"Loader_root__nRh6u","error":"Loader_error__xdu-p","placeHolderShimmer":"Loader_placeHolderShimmer__vsgXj"};